(function () {
  const SELECTORS = {
    root: '[data-inshape-quiz]',
    config: '[data-inshape-quiz-config]',
    start: '[data-quiz-start]',
    back: '[data-quiz-back]',
    next: '[data-quiz-next]',
    action: '[data-quiz-action]',
    restart: '[data-quiz-restart]',
    views: '[data-quiz-view]',
    title: '[data-quiz-question-title]',
    helper: '[data-quiz-question-helper]',
    options: '[data-quiz-options]',
    stepLabel: '[data-quiz-step-label]',
    progress: '[data-quiz-progress]',
    loadingLabel: '[data-quiz-loading-label]',
    loadingHeading: '[data-quiz-loading-heading]',
    loadingProgress: '[data-quiz-loading-progress]',
    resultEyebrow: '[data-quiz-result-eyebrow]',
    resultHeadline: '[data-quiz-result-headline]',
    resultBody: '[data-quiz-result-body]',
    resultIssue: '[data-quiz-result-issue]',
    resultSkeptic: '[data-quiz-result-skeptic]',
    resultBullets: '[data-quiz-result-bullets]',
    resultProof: '[data-quiz-result-proof]',
    resultSizeLabel: '[data-quiz-result-size-label]',
    resultSize: '[data-quiz-result-size]',
    resultSizeHelper: '[data-quiz-result-size-helper]',
    resultProductReason: '[data-quiz-result-product-reason]',
    resultSizeReason: '[data-quiz-result-size-reason]',
    resultSummaryNote: '[data-quiz-result-summary-note]',
    resultCardSize: '[data-quiz-result-card-size]',
    resultCardPill: '[data-quiz-result-card-pill]',
    resultCardCtaHelper: '[data-quiz-result-cta-helper]',
    resultProductTitle: '[data-quiz-result-product-title]',
    resultCta: '[data-quiz-result-cta]',
    resultCardCta: '[data-quiz-result-card-cta]',
    resultCtaTriggers: '[data-quiz-result-cta], [data-quiz-result-card-cta]'
  };

  const QUIZ_VERSION = 'buyer_profile_quiz_v1';
  const QUIZ_SESSION_STORAGE_KEY = 'inshape_quiz_session_v1';
  const QUIZ_PROFILE_STORAGE_KEY = 'inshape_quiz_profile_v1';
  const ATTRIBUTION_QUERY_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_id',
    'fbclid',
    'gclid',
    'ttclid'
  ];

  const RESULT_COPY = {
    executive_presence: {
      headline: 'This Is Your Best Starting Match',
      productReason: 'This tank stood out because you want sharper shirts without obvious bulk or compression lines.'
    },
    everyday_dad_confidence: {
      headline: 'This Is Your Best Starting Match',
      productReason: 'This tank stood out because you want tees and polos to fit better without looking obvious.'
    },
    all_day_support: {
      headline: 'This Is Your Best Starting Match',
      productReason: 'This tank stood out because you want extra support through longer days without adding bulk under a shirt.'
    }
  };

  const ISSUE_REASON_LINES = {
    stomach: 'You also said midsection smoothing is the biggest improvement you want.',
    chest: 'You also said chest visibility is the main thing you want to keep more discreet.',
    bunching: 'You also said bunching and visible lines are a major frustration.',
    support: 'You also said posture and staying upright matter during the day.'
  };

  const DEFAULT_PRODUCT_BENEFITS = [
    'Sculpts your body instantly',
    'Supports your posture',
    'Invisible under clothes'
  ];

  function createBenefitIconMarkup() {
    return '<span class="inshape-quiz__product-benefit-icon" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 11.75C22.5 17.6871 17.6871 22.5 11.75 22.5C5.81294 22.5 1 17.6871 1 11.75C1 5.81294 5.81294 1 11.75 1C17.6871 1 22.5 5.81294 22.5 11.75ZM15.2803 10.2803C15.5732 9.98744 15.5732 9.51256 15.2803 9.21967C14.9874 8.92678 14.5126 8.92678 14.2197 9.21967L10.75 12.6893L9.28033 11.2197C8.98744 10.9268 8.51256 10.9268 8.21967 11.2197C7.92678 11.5126 7.92678 11.9874 8.21967 12.2803L10.2197 14.2803C10.5126 14.5732 10.9874 14.5732 11.2803 14.2803L15.2803 10.2803Z" fill="#0C0C0D"></path></svg></span>';
  }

  function formatRestartLabel(value) {
    return 'Start over';
  }

  function setText(node, value) {
    if (node) {
      node.textContent = value || '';
    }
  }

  function buildProductReason(laneCopy, issueLine) {
    return [laneCopy.productReason, issueLine].filter(Boolean).join(' ');
  }

  function createQuizId(prefix) {
    return [prefix, Date.now().toString(36), Math.random().toString(36).slice(2, 10)].join('_');
  }

  function nowIso() {
    return new Date().toISOString();
  }

  function safeStorageWrite(storage, key, value) {
    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return false;
    }

    return true;
  }

  function safeStorageRemove(storage, key) {
    try {
      storage.removeItem(key);
    } catch (error) {
      return false;
    }

    return true;
  }

  function readAttributionParams() {
    const params = new URLSearchParams(window.location.search);
    const values = {};

    ATTRIBUTION_QUERY_KEYS.forEach((key) => {
      const value = params.get(key);

      if (value) {
        values[key] = value;
      }
    });

    return values;
  }

  function emitAnalyticsEvent(eventName, payload) {
    const analyticsPayload = Object.assign(
      {
        quiz_version: QUIZ_VERSION
      },
      payload || {}
    );

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, analyticsPayload);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, analyticsPayload));
  }

  class InShapeQuiz {
    constructor(root) {
      this.root = root;
      this.config = this.parseConfig();
      this.questions = this.config.questions || [];
      this.sessionId = null;
      this.sessionStartedAt = null;
      this.sessionLandingPath = window.location.pathname;
      this.attribution = readAttributionParams();
      this.hasTrackedComplete = false;
      this.state = {
        currentStep: -1,
        answers: {
          issues: []
        }
      };
      this.loadingInterval = null;
      this.loadingTimeout = null;

      this.views = Array.from(this.root.querySelectorAll(SELECTORS.views)).reduce((acc, node) => {
        acc[node.dataset.quizView] = node;
        return acc;
      }, {});

      this.elements = {
        start: this.root.querySelector(SELECTORS.start),
        back: this.root.querySelector(SELECTORS.back),
        next: this.root.querySelector(SELECTORS.next),
        action: this.root.querySelector(SELECTORS.action),
        title: this.root.querySelector(SELECTORS.title),
        helper: this.root.querySelector(SELECTORS.helper),
        options: this.root.querySelector(SELECTORS.options),
        stepLabel: this.root.querySelector(SELECTORS.stepLabel),
        progress: this.root.querySelector(SELECTORS.progress),
        loadingLabel: this.root.querySelector(SELECTORS.loadingLabel),
        loadingHeading: this.root.querySelector(SELECTORS.loadingHeading),
        loadingProgress: this.root.querySelector(SELECTORS.loadingProgress),
        resultEyebrow: this.root.querySelector(SELECTORS.resultEyebrow),
        resultHeadline: this.root.querySelector(SELECTORS.resultHeadline),
        resultBody: this.root.querySelector(SELECTORS.resultBody),
        resultIssue: this.root.querySelector(SELECTORS.resultIssue),
        resultSkeptic: this.root.querySelector(SELECTORS.resultSkeptic),
        resultBullets: this.root.querySelector(SELECTORS.resultBullets),
        resultProof: this.root.querySelector(SELECTORS.resultProof),
        resultSizeLabel: this.root.querySelector(SELECTORS.resultSizeLabel),
        resultSize: this.root.querySelector(SELECTORS.resultSize),
        resultSizeHelper: this.root.querySelector(SELECTORS.resultSizeHelper),
        resultProductReason: this.root.querySelector(SELECTORS.resultProductReason),
        resultSizeReason: this.root.querySelector(SELECTORS.resultSizeReason),
        resultSummaryNote: this.root.querySelector(SELECTORS.resultSummaryNote),
        resultCardSize: this.root.querySelector(SELECTORS.resultCardSize),
        resultCardPill: this.root.querySelector(SELECTORS.resultCardPill),
        resultCardCtaHelper: this.root.querySelector(SELECTORS.resultCardCtaHelper),
        resultProductTitle: this.root.querySelector(SELECTORS.resultProductTitle),
        resultCta: this.root.querySelector(SELECTORS.resultCta),
        resultCardCta: this.root.querySelector(SELECTORS.resultCardCta),
        restart: this.root.querySelector(SELECTORS.restart)
      };

      this.bindEvents();
      this.showView('landing');
    }

    parseConfig() {
      const node = this.root.querySelector(SELECTORS.config);
      if (!node) {
        return { questions: [] };
      }

      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        console.error('InShape quiz config could not be parsed.', error);
        return { questions: [] };
      }
    }

    bindEvents() {
      if (this.elements.start) {
        this.elements.start.addEventListener('click', () => this.startQuiz());
      }

      if (this.elements.back) {
        this.elements.back.addEventListener('click', () => this.goBack());
      }

      if (this.elements.next) {
        this.elements.next.addEventListener('click', () => this.advanceFromMulti());
      }

      this.root.addEventListener('click', (event) => {
        const restartTrigger = event.target.closest(SELECTORS.restart);
        const resultCtaTrigger = event.target.closest(SELECTORS.resultCtaTriggers);

        if (restartTrigger && this.root.contains(restartTrigger)) {
          event.preventDefault();
          this.resetQuiz();
          return;
        }

        if (resultCtaTrigger && this.root.contains(resultCtaTrigger)) {
          this.trackResultCtaClick(resultCtaTrigger);
        }
      });
    }

    startQuiz() {
      this.ensureSession();
      this.state.currentStep = 0;
      this.renderQuestion();
      this.showView('question');
      this.scrollQuizToTop();
    }

    resetQuiz() {
      this.clearLoadingTimers();
      this.clearStoredSession();
      this.sessionId = null;
      this.sessionStartedAt = null;
      this.hasTrackedComplete = false;
      this.state = {
        currentStep: -1,
        answers: {
          issues: []
        }
      };
      this.showView('landing');
    }

    goBack() {
      if (this.state.currentStep <= 0) {
        this.showView('landing');
        this.state.currentStep = -1;
        return;
      }

      this.state.currentStep -= 1;
      this.renderQuestion();
      this.showView('question');
    }

    showView(viewName) {
      Object.entries(this.views).forEach(([name, node]) => {
        node.classList.toggle('is-active', name === viewName);
      });
    }

    focusNode(node) {
      if (!node || typeof node.focus !== 'function') {
        return;
      }

      window.setTimeout(() => {
        node.focus({ preventScroll: true });
      }, 40);
    }

    renderQuestion() {
      const question = this.questions[this.state.currentStep];
      if (!question) {
        return;
      }

      this.elements.title.textContent = question.prompt || '';

      if (question.helper) {
        this.elements.helper.hidden = false;
        this.elements.helper.textContent = question.helper;
      } else {
        this.elements.helper.hidden = true;
        this.elements.helper.textContent = '';
      }

      this.elements.stepLabel.textContent = `${this.state.currentStep + 1} of ${this.questions.length}`;
      this.elements.progress.style.width = `${((this.state.currentStep + 1) / this.questions.length) * 100}%`;
      this.elements.next.hidden = question.type !== 'multi';
      this.elements.action.hidden = question.type !== 'multi';
      this.elements.options.dataset.questionId = question.id;
      this.elements.options.dataset.questionType = question.type;

      if (question.type === 'multi') {
        this.elements.next.disabled = !(this.state.answers[question.id] || []).length;
      }

      this.renderOptions(question);
      this.trackStepView(question);
    }

    renderOptions(question) {
      this.elements.options.innerHTML = '';
      const selectedValue = this.state.answers[question.id];

      question.options.forEach((option, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `inshape-quiz__option inshape-quiz__option--${question.type}`;
        button.dataset.optionIndex = String(index);
        button.dataset.questionId = question.id;

        if (question.type === 'multi') {
          const selected = Array.isArray(selectedValue) && selectedValue.includes(index);
          button.classList.toggle('is-selected', selected);
        } else if (selectedValue === index) {
          button.classList.add('is-selected');
        }

        const iconMarkup = this.getOptionIconMarkup(question, option);

        if (iconMarkup) {
          const iconWrap = document.createElement('span');
          iconWrap.className = 'inshape-quiz__option-icon';
          iconWrap.setAttribute('aria-hidden', 'true');
          iconWrap.innerHTML = iconMarkup;
          button.appendChild(iconWrap);
        }

        const label = document.createElement('span');
        label.className = 'inshape-quiz__option-label';
        label.textContent = option;

        button.appendChild(label);

        if (question.type === 'multi') {
          const indicator = document.createElement('span');
          indicator.className = 'inshape-quiz__option-indicator inshape-quiz__option-indicator--multi';
          indicator.textContent = '✓';
          button.appendChild(indicator);
        } else if (question.id !== 'age' && question.id !== 'size') {
          const indicator = document.createElement('span');
          indicator.className = 'inshape-quiz__option-indicator inshape-quiz__option-indicator--single';
          button.appendChild(indicator);
        }

        button.addEventListener('click', () => this.handleOptionSelect(question, index));
        this.elements.options.appendChild(button);
      });
    }

    getOptionIconMarkup(question, option) {
      return '';
    }

    handleOptionSelect(question, index) {
      const optionLabel = question.options[index] || '';

      if (question.type === 'multi') {
        const current = Array.isArray(this.state.answers[question.id]) ? [...this.state.answers[question.id]] : [];
        const selectedIndex = current.indexOf(index);
        let isSelected = false;

        if (selectedIndex > -1) {
          current.splice(selectedIndex, 1);
        } else {
          current.push(index);
          isSelected = true;
        }

        this.state.answers[question.id] = current;
        this.renderOptions(question);
        this.elements.next.disabled = current.length === 0;
        this.persistSessionState();
        this.trackEvent('quiz_answer', {
          step_number: this.state.currentStep + 1,
          question_id: question.id,
          question_label: question.prompt || '',
          answer_label: optionLabel,
          answer_index: index,
          selection_state: isSelected ? 'selected' : 'removed'
        });
        return;
      }

      this.state.answers[question.id] = index;
      this.renderOptions(question);
      this.persistSessionState();
      this.trackEvent('quiz_answer', {
        step_number: this.state.currentStep + 1,
        question_id: question.id,
        question_label: question.prompt || '',
        answer_label: optionLabel,
        answer_index: index
      });

      window.setTimeout(() => {
        this.advanceStep();
      }, 120);
    }

    advanceFromMulti() {
      const question = this.questions[this.state.currentStep];
      if (!question || question.type !== 'multi') {
        return;
      }

      if (!(this.state.answers[question.id] || []).length) {
        return;
      }

      this.advanceStep();
    }

    advanceStep() {
      if (this.state.currentStep >= this.questions.length - 1) {
        this.startLoading();
        return;
      }

      this.state.currentStep += 1;
      this.renderQuestion();
      this.showView('question');
    }

    startLoading() {
      this.trackQuizComplete();
      this.ensureLoadingLayout();
      this.showView('loading');
      this.scrollQuizToTop();
      this.focusNode(this.elements.loadingHeading);
      this.clearLoadingTimers();
      window.setTimeout(() => this.refreshLoadingCarousel(), 50);
      window.setTimeout(() => this.refreshLoadingCarousel(), 250);

      const durationSeconds = Number(this.config.loadingDuration) || 9;
      const totalMs = durationSeconds * 1000;
      const startTime = Date.now();

      if (this.elements.loadingProgress) {
        this.elements.loadingProgress.style.width = '0%';
      }

      this.loadingInterval = window.setInterval(() => {
        const elapsed = Date.now() - startTime;
        const remaining = Math.max(totalMs - elapsed, 0);
        const progress = Math.min((elapsed / totalMs) * 100, 100);

        if (this.elements.loadingProgress) {
          this.elements.loadingProgress.style.width = `${progress}%`;
        }

        if (remaining <= 0) {
          window.clearInterval(this.loadingInterval);
          this.loadingInterval = null;
        }
      }, 120);

      this.loadingTimeout = window.setTimeout(() => {
        this.clearLoadingTimers();
        this.renderResult();
      }, totalMs);
    }

    refreshLoadingCarousel() {
      const carousel = this.root.querySelector('[data-quiz-loading-carousel]');

      if (!carousel) {
        return;
      }

      if (this.loadingCarouselInterval) {
        window.clearInterval(this.loadingCarouselInterval);
        this.loadingCarouselInterval = null;
      }

      const slides = Array.from(carousel.querySelectorAll('.inshape-quiz__testimonial-slide'));

      if (!slides.length) {
        return;
      }

      let activeIndex = 0;

      slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === 0);
      });

      if (slides.length === 1) {
        return;
      }

      this.loadingCarouselInterval = window.setInterval(() => {
        slides[activeIndex].classList.remove('is-active');
        activeIndex = (activeIndex + 1) % slides.length;
        slides[activeIndex].classList.add('is-active');
      }, 2200);
    }

    ensureLoadingLayout() {
      const loadingView = this.views.loading;

      if (!loadingView) {
        return;
      }

      const shell = loadingView.querySelector('.inshape-quiz__shell--loading');

      if (!shell) {
        return;
      }

      const header = shell.querySelector('.inshape-quiz__loading-header');
      const carouselShell = shell.querySelector('.inshape-quiz__loading-carousel-shell');
      const progressTrack = shell.querySelector('.inshape-quiz__progress-track--loading');
      const loadingMessage = shell.querySelector('.inshape-quiz__loading-message');

      if (carouselShell) {
        carouselShell.style.display = '';
        carouselShell.style.order = '';
      }

      if (progressTrack) {
        progressTrack.style.display = 'block';
        progressTrack.style.order = '';
      }

      if (loadingMessage) {
        loadingMessage.style.display = 'block';
        loadingMessage.style.order = '';
      }

      if (header && progressTrack) {
        shell.insertBefore(progressTrack, carouselShell || loadingMessage || null);
      }

      if (carouselShell && progressTrack) {
        shell.insertBefore(carouselShell, progressTrack.nextSibling);
      }

      if (loadingMessage && carouselShell) {
        shell.insertBefore(loadingMessage, carouselShell.nextSibling);
      }
    }

    scrollQuizToTop() {
      const top = this.root.getBoundingClientRect().top + window.scrollY - 8;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'auto' });
    }

    clearLoadingTimers() {
      if (this.loadingInterval) {
        window.clearInterval(this.loadingInterval);
        this.loadingInterval = null;
      }

      if (this.loadingCarouselInterval) {
        window.clearInterval(this.loadingCarouselInterval);
        this.loadingCarouselInterval = null;
      }

      if (this.loadingTimeout) {
        window.clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
    }

    determineLane() {
      const shirt = this.state.answers.shirt;
      const context = this.state.answers.context;
      const issue = this.state.answers.issue;
      const priority = this.state.answers.priority;

      if (context === 2 || issue === 3 || priority === 3) {
        return 'all_day_support';
      }

      if (context === 0 || shirt === 1 || shirt === 2) {
        return 'executive_presence';
      }

      return 'everyday_dad_confidence';
    }

    determineIssueKey() {
      const issueIndex = typeof this.state.answers.issue === 'number' ? this.state.answers.issue : 0;
      return ['stomach', 'chest', 'bunching', 'support'][issueIndex] || 'stomach';
    }

    getQuestionById(questionId) {
      return this.questions.find((question) => question.id === questionId) || null;
    }

    getQuestionAnswerValue(questionId) {
      const question = this.getQuestionById(questionId);

      if (!question) {
        return '';
      }

      const answer = this.state.answers[questionId];

      if (Array.isArray(answer)) {
        return answer.map((index) => question.options[index]).filter(Boolean);
      }

      if (typeof answer === 'number') {
        return question.options[answer] || '';
      }

      return '';
    }

    buildAnswerLabelMap() {
      return this.questions.reduce((acc, question) => {
        const value = this.getQuestionAnswerValue(question.id);

        if (Array.isArray(value) ? value.length : value) {
          acc[question.id] = value;
        }

        return acc;
      }, {});
    }

    getResultSummary() {
      const laneKey = this.determineLane();
      const issueKey = this.determineIssueKey();
      const sizeValue = this.getQuestionAnswerValue('size');
      const resultUrl = this.buildResultUrl(laneKey, issueKey, sizeValue);

      return {
        laneKey,
        issueKey,
        sizeValue,
        resultUrl
      };
    }

    buildResultUrl(laneKey, issueKey, sizeValue) {
      const url = new URL(this.config.resultPathBase || '/products/inshape-beaters', window.location.origin);
      url.searchParams.set('utm_funnel', this.config.utmFunnel || 'buyer_profile_quiz_v1');
      url.searchParams.set('utm_lane', laneKey);
      url.searchParams.set('utm_issue', issueKey);
      const variantId = this.findVariantId(sizeValue);

      if (variantId) {
        url.searchParams.set('variant', String(variantId));
      }

      if (sizeValue) {
        url.searchParams.set('utm_size', sizeValue);
      }
      return `${url.pathname}${url.search}`;
    }

    buildAnalyticsPayload(extra) {
      const hasIssueAnswer = typeof this.state.answers.issue === 'number';
      const hasSizeAnswer = typeof this.state.answers.size === 'number';
      const hasLaneAnswers = ['shirt', 'context', 'issue', 'priority'].every((questionId) => typeof this.state.answers[questionId] === 'number');

      return Object.assign(
        {
          quiz_session_id: this.sessionId || '',
          quiz_path: window.location.pathname,
          utm_funnel: this.config.utmFunnel || QUIZ_VERSION,
          lane: hasLaneAnswers ? this.determineLane() : '',
          issue: hasIssueAnswer ? this.determineIssueKey() : '',
          size: hasSizeAnswer ? this.getQuestionAnswerValue('size') : '',
          elapsed_seconds: this.sessionStartedAt ? Math.round((Date.now() - this.sessionStartedAt) / 1000) : 0
        },
        extra || {}
      );
    }

    trackEvent(eventName, extra) {
      emitAnalyticsEvent(eventName, this.buildAnalyticsPayload(extra));
    }

    ensureSession() {
      if (this.sessionId) {
        return;
      }

      this.sessionId = createQuizId('quiz');
      this.sessionStartedAt = Date.now();
      this.sessionLandingPath = window.location.pathname;
      this.hasTrackedComplete = false;
      this.persistSessionState();
      this.trackEvent('quiz_start', {
        step_number: 1
      });
    }

    persistSessionState() {
      if (!this.sessionId) {
        return;
      }

      safeStorageWrite(window.sessionStorage, QUIZ_SESSION_STORAGE_KEY, {
        quizVersion: QUIZ_VERSION,
        sessionId: this.sessionId,
        startedAt: this.sessionStartedAt ? new Date(this.sessionStartedAt).toISOString() : '',
        currentStep: this.state.currentStep,
        answerLabels: this.buildAnswerLabelMap(),
        attribution: this.attribution,
        landingPath: this.sessionLandingPath,
        updatedAt: nowIso()
      });
    }

    clearStoredSession() {
      safeStorageRemove(window.sessionStorage, QUIZ_SESSION_STORAGE_KEY);
    }

    persistCompletedProfile(summary) {
      safeStorageWrite(window.localStorage, QUIZ_PROFILE_STORAGE_KEY, {
        quizVersion: QUIZ_VERSION,
        sessionId: this.sessionId,
        startedAt: this.sessionStartedAt ? new Date(this.sessionStartedAt).toISOString() : '',
        completedAt: nowIso(),
        lane: summary.laneKey,
        issue: summary.issueKey,
        size: summary.sizeValue || '',
        answerLabels: this.buildAnswerLabelMap(),
        attribution: this.attribution,
        sourcePath: window.location.pathname,
        landingPath: this.sessionLandingPath,
        resultPathBase: this.config.resultPathBase || '',
        resultUrl: summary.resultUrl
      });
    }

    trackStepView(question) {
      this.trackEvent('quiz_step_view', {
        step_number: this.state.currentStep + 1,
        question_id: question.id,
        question_label: question.prompt || ''
      });
    }

    trackQuizComplete() {
      if (this.hasTrackedComplete) {
        return;
      }

      this.hasTrackedComplete = true;
      this.trackEvent('quiz_complete', {
        step_number: this.questions.length
      });
    }

    trackResultCtaClick(target) {
      const href = target && target.getAttribute('href') ? target.getAttribute('href') : '';

      this.trackEvent('quiz_cta_click', {
        cta_destination: href || ''
      });
    }

    findVariantId(sizeValue) {
      if (!sizeValue) {
        return '';
      }

      return (this.config.sizeVariantIds && this.config.sizeVariantIds[sizeValue]) || '';
    }

    buildCtaLabel() {
      return this.config.result.ctaLabel || 'SEE MY RECOMMENDED TANK';
    }

    getProductBenefits() {
      if (Array.isArray(this.config.productBenefits) && this.config.productBenefits.length) {
        return this.config.productBenefits;
      }

      return DEFAULT_PRODUCT_BENEFITS;
    }

    ensureResultLayout() {
      const resultView = this.views.result;

      if (!resultView) {
        return;
      }

      if (this.elements.resultHeadline) {
        this.elements.resultHeadline.style.maxWidth = 'none';
        this.elements.resultHeadline.style.lineHeight = '1.08';
      }

      const productBody = resultView.querySelector('.inshape-quiz__product-body');
      const title = this.elements.resultProductTitle;
      const actions = resultView.querySelector('.inshape-quiz__product-actions');
      const topbar = resultView.querySelector('.inshape-quiz__question-topbar--result');
      const cta = resultView.querySelector(SELECTORS.resultCardCta);
      const reasonsBlocks = Array.from(resultView.querySelectorAll('.inshape-quiz__result-reasons'));
      const reasons = reasonsBlocks[0] || null;
      let summary = resultView.querySelector('.inshape-quiz__product-summary');
      let review = resultView.querySelector('.inshape-quiz__product-review');
      let benefits = resultView.querySelector('.inshape-quiz__product-benefits');
      const restartButtons = Array.from(resultView.querySelectorAll(SELECTORS.restart));
      let restart = restartButtons[0] || null;

      if (productBody && !review) {
        review = document.createElement('p');
        review.className = 'inshape-quiz__product-review';
        review.innerHTML = '<span class="inshape-quiz__product-review-stars" aria-hidden="true">★★★★★</span><span>Trusted by 10,000+ Men</span>';
      }

      if (productBody && review && title && review !== title.previousElementSibling) {
        productBody.insertBefore(review, title);
      }

      if (productBody && !benefits) {
        benefits = document.createElement('ul');
        benefits.className = 'inshape-quiz__product-benefits';
        benefits.setAttribute('role', 'list');
      }

      if (benefits) {
        benefits.innerHTML = '';
        this.getProductBenefits().forEach((benefit) => {
          const item = document.createElement('li');
          item.innerHTML = createBenefitIconMarkup() + '<span>' + benefit + '</span>';
          benefits.appendChild(item);
        });
        benefits.style.display = 'grid';
        benefits.style.gap = '10px';
      }

      if (productBody && benefits && title && benefits !== title.nextElementSibling) {
        title.insertAdjacentElement('afterend', benefits);
      }

      if (summary && actions && summary.parentElement !== actions) {
        summary.classList.add('inshape-quiz__product-summary--actions');
        actions.insertBefore(summary, actions.firstChild);
      }

      if (reasons && actions && cta && reasons.parentElement !== actions) {
        actions.appendChild(reasons);
      }

      reasonsBlocks.forEach((block) => {
        if (block !== reasons) {
          block.remove();
        }
      });

      if (topbar) {
        if (!restart) {
          restart = document.createElement('button');
          restart.type = 'button';
          restart.setAttribute('data-quiz-restart', '');
        }

        restart.className = 'inshape-quiz__back inshape-quiz__back--restart';
        restart.textContent = formatRestartLabel(this.config.restartLabel);
        restart.style.textTransform = 'none';
        restart.style.letterSpacing = '0';
        topbar.insertBefore(restart, topbar.firstChild);

        restartButtons.forEach((button) => {
          if (button !== restart) {
            button.remove();
          }
        });

        const topbarSpacers = topbar.querySelectorAll('.inshape-quiz__topbar-spacer');
        if (topbarSpacers.length > 1) {
          topbarSpacers[0].remove();
        }
      }
    }

    renderResult() {
      const summary = this.getResultSummary();
      const laneKey = summary.laneKey;
      const lane = RESULT_COPY[laneKey] || RESULT_COPY.everyday_dad_confidence;
      const sizeValue = summary.sizeValue || '';
      const issueKey = summary.issueKey;
      const issueLine = ISSUE_REASON_LINES[issueKey] || '';
      const resultUrl = summary.resultUrl;
      const ctaLabel = this.buildCtaLabel();

      setText(this.elements.resultEyebrow, this.config.result.eyebrow || '');
      setText(this.elements.resultHeadline, lane.headline || this.config.result.productTitle || '');
      setText(this.elements.resultProductReason, buildProductReason(lane, issueLine));
      setText(this.elements.resultCardSize, sizeValue);
      setText(this.elements.resultProductTitle, this.config.result.productTitle || '');
      this.ensureResultLayout();

      if (this.elements.resultCta) {
        this.elements.resultCta.href = resultUrl;
        this.elements.resultCta.textContent = ctaLabel;
      }

      if (this.elements.resultCardCta) {
        this.elements.resultCardCta.href = resultUrl;
        this.elements.resultCardCta.textContent = ctaLabel;
        this.elements.resultCardCta.setAttribute('aria-label', sizeValue ? `Open the recommended product page with size ${sizeValue} selected` : 'Open the recommended product page');
      }

      this.persistCompletedProfile(summary);
      this.clearStoredSession();
      this.trackEvent('quiz_result_view', {
        step_number: this.questions.length
      });
      this.showView('result');
      this.scrollQuizToTop();
      this.focusNode(this.elements.resultHeadline);
    }

    destroy() {
      this.clearLoadingTimers();
      this.root.dataset.quizReady = 'false';
    }
  }

  function initQuiz(section) {
    const root = section.querySelector(SELECTORS.root);
    if (!root || root.dataset.quizReady === 'true') {
      return;
    }

    root.dataset.quizReady = 'true';
    root.quizInstance = new InShapeQuiz(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTORS.root).forEach((root) => {
      const section = root.closest('.shopify-section') || root.parentElement;
      if (section) {
        initQuiz(section);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(SELECTORS.root).forEach((root) => {
      if (root.quizInstance) {
        root.quizInstance.destroy();
      }
    });
  });
})();
